import { useState } from 'react';
import { Button, Col, Collapse, Form, InputGroup, Row } from 'react-bootstrap';

// Busca das listagens (pedido por Jason: "um input pra digitar e buscar, com
// botão pra avançado e ali sim ter tudo pra procurar"). O campo simples manda
// `q` (o backend procura em vários campos de uma vez); o painel avançado manda
// um parâmetro por campo — ver painel-eimovel-node `src/filtros.js` pra lista
// exata de parâmetros aceitos por Clientes e Leads.
//
// `campos`: [{ nome, rotulo, tipo: 'text' | 'date' | 'select', opcoes?: [{ valor, rotulo }] }]
// `aoBuscar(filtros)`: recebe só os filtros preenchidos (`{}` = sem filtro).
// `initialQ`: pré-preenche a busca simples — usado pelo link "ver todos" da busca geral do
// Dashboard (`?q=...` na URL), pra já chegar filtrado em vez de precisar digitar de novo.
export default function BuscaAvancada({ campos, placeholderSimples, aoBuscar, initialQ = '' }) {
  const [q, setQ] = useState(initialQ);
  const [valores, setValores] = useState({});
  const [aberto, setAberto] = useState(false);

  const preenchidos = Object.values(valores).filter((v) => v !== '' && v != null).length;

  function montarFiltros() {
    const filtros = {};
    if (q.trim()) filtros.q = q.trim();
    for (const [nome, valor] of Object.entries(valores)) {
      if (valor !== '' && valor != null) filtros[nome] = valor;
    }
    return filtros;
  }

  function aoEnviar(e) {
    e.preventDefault();
    aoBuscar(montarFiltros());
  }

  function limpar() {
    setQ('');
    setValores({});
    aoBuscar({});
  }

  function atualizarCampo(nome, valor) {
    setValores((v) => ({ ...v, [nome]: valor }));
  }

  return (
    <Form onSubmit={aoEnviar} className="mb-3">
      <InputGroup>
        <Form.Control
          type="search"
          placeholder={placeholderSimples}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label="Buscar"
        />
        <Button type="submit" variant="primary">
          Buscar
        </Button>
        <Button
          type="button"
          variant={preenchidos > 0 ? 'secondary' : 'outline-secondary'}
          onClick={() => setAberto((a) => !a)}
          aria-expanded={aberto}
        >
          Avançado{preenchidos > 0 ? ` (${preenchidos})` : ''}
        </Button>
      </InputGroup>

      <Collapse in={aberto}>
        <div>
          <div className="border rounded p-3 mt-2 bg-white">
            <Row className="g-3">
              {campos.map((campo) => (
                <Col sm={6} lg={3} key={campo.nome}>
                  <Form.Group controlId={`busca-${campo.nome}`}>
                    <Form.Label className="small mb-1">{campo.rotulo}</Form.Label>
                    {campo.tipo === 'select' ? (
                      <Form.Select
                        size="sm"
                        value={valores[campo.nome] ?? ''}
                        onChange={(e) => atualizarCampo(campo.nome, e.target.value)}
                      >
                        <option value="">Todos</option>
                        {campo.opcoes.map((op) => (
                          <option key={op.valor} value={op.valor}>
                            {op.rotulo}
                          </option>
                        ))}
                      </Form.Select>
                    ) : (
                      <Form.Control
                        size="sm"
                        type={campo.tipo === 'date' ? 'date' : 'text'}
                        maxLength={campo.tipo === 'date' ? undefined : 100}
                        value={valores[campo.nome] ?? ''}
                        onChange={(e) => atualizarCampo(campo.nome, e.target.value)}
                      />
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>
            <div className="d-flex gap-2 mt-3">
              <Button type="submit" size="sm" variant="primary">
                Buscar
              </Button>
              <Button type="button" size="sm" variant="outline-secondary" onClick={limpar}>
                Limpar filtros
              </Button>
            </div>
          </div>
        </div>
      </Collapse>
    </Form>
  );
}
